import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragAndDropModule } from 'angular-draggable-droppable';
import { CalendarMonthViewComponent } from './calendar-month-view.component';
import { CalendarMonthViewHeaderComponent } from './calendar-month-view-header.component';
import { CalendarMonthCellComponent } from './calendar-month-cell.component';
import { CalendarOpenDayEventsComponent } from './calendar-open-day-events.component';
import { CalendarCommonModule } from '../common/calendar-common.module';

import { CalendarMonthCustomCellComponent } from './calendar-month-custom-cell.component';


import { CalendarCustomMonthViewComponent } from './calendar-custom-month-view.component';

import { Pipe, PipeTransform } from '@angular/core';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  },
  green: {
    primary: '#07aa09',
    secondary: '#07aa09'
  }
};

function deepClone(obj) {
  var visitedNodes = [];
  var clonedCopy = [];
  function clone(item) {
      if (typeof item === "object" && !Array.isArray(item)) {
          if (visitedNodes.indexOf(item) === -1) {
              visitedNodes.push(item);
              var cloneObject = {};
              clonedCopy.push(cloneObject);
              for (var i in item) {
                  if (item.hasOwnProperty(i)) {
                      cloneObject[i] = clone(item[i]);
                  }
              }
              return cloneObject;
          } else {
              return clonedCopy[visitedNodes.indexOf(item)];
          }
      }
      else if (typeof item === "object" && Array.isArray(item)) {
          if (visitedNodes.indexOf(item) === -1) {
              var cloneArray = [];
              visitedNodes.push(item);
              clonedCopy.push(cloneArray);
              for (var j = 0; j < item.length; j++) {
                  cloneArray.push(clone(item[j]));
              }
              return cloneArray;
          } else {
              return clonedCopy[visitedNodes.indexOf(item)];
          }
      }

      return item; // not object, not array, therefore primitive
  }
  return clone(obj);
}



@Pipe({
  name: 'eventsFilters'
})
export class EventsFiltersPipe implements PipeTransform {
  transform(events1: any[]): any {
    

    let events = deepClone(events1);

    let totalDocs = 0;
    let avalDocs = [];
    let hasSwapRequest = 0;; 
    

    events.forEach(function(event){
      if (event.provider_schedules && event.provider_schedules.length>0){
        hasSwapRequest = event.provider_schedules.filter(function (schd) {
          return schd.swap_request;
        }).length;
      }

      totalDocs = event.totalDocs;
      event.doctors.forEach(er => {
        avalDocs.push(er);
      });
    });
    
    //console.log(totalDocs, avalDocs);


  let _events = events[0];
    _events['reqDocs'] = totalDocs;
    _events['avalDocs'] = avalDocs.length;
    _events['hasSwapRequest'] = hasSwapRequest > 0;


    //console.log(_events['start'], _events['reqDocs'], _events['avalDocs'], _events['hasSwapRequest']);  
    

    if (_events && _events.hasOwnProperty('reqDocs') && _events.hasOwnProperty('avalDocs') && _events.hasOwnProperty('color')){
      // if (_events['avalDocs'] === 0) {
      //   _events['color'] = colors['red'];
      //   _events['cssClass'] = "fa fa-times";
      if (_events['hasSwapRequest'] > 0){
        _events['color'] = colors['yellow'];
        _events['cssClass'] = "fa fa-exclamation-triangle";
      // }else if (_events['reqDocs'] > _events['avalDocs']){
      //   _events['color'] = colors['yellow'];
      //   _events['cssClass'] = "fa fa-exclamation-triangle";
      }else if (_events['reqDocs'] > _events['avalDocs']) {
        _events['color'] = colors['red'];
        _events['cssClass'] = "fa fa-times";
      }else{
        _events['color'] = colors['green'];
        _events['cssClass'] = "fa fa-check";
      }  
    }
    //console.log(_events);
    return new Array(_events);
  }
}


export {
  CalendarMonthViewComponent,
  CalendarMonthViewBeforeRenderEvent,
  CalendarMonthViewEventTimesChangedEvent
} from './calendar-month-view.component';
export { MonthViewDay as CalendarMonthViewDay } from 'calendar-utils';

@NgModule({
  imports: [CommonModule, DragAndDropModule, CalendarCommonModule],
  declarations: [
    CalendarMonthViewComponent,
    CalendarMonthCellComponent,
    CalendarOpenDayEventsComponent,
    CalendarMonthViewHeaderComponent,
    CalendarCustomMonthViewComponent,
    CalendarMonthCustomCellComponent,
    EventsFiltersPipe
  ],
  exports: [
    DragAndDropModule,
    CalendarMonthViewComponent,
    CalendarMonthCellComponent,
    CalendarOpenDayEventsComponent,
    CalendarMonthViewHeaderComponent,
    CalendarCustomMonthViewComponent,
    CalendarMonthCustomCellComponent,
    EventsFiltersPipe
  ]
})
export class CalendarMonthModule {}



// WEBPACK FOOTER //
// ./src/app/modules/calendar/month/calendar-month.module.ts